import { memo, useEffect, useMemo, useState } from "react";
import useValidate from "../../../store/hooks/useValidator";
import { useDispatch, useSelector } from "react-redux";
import { callApiAction } from "../../../store/actions/commonAction";

import { closeModal } from "../../../store/actions/modalAction";
import { useParams } from "react-router-dom";
import {
  GENDER,
  SNACK_BAR_VARIETNS,
  USER_ROLES,
} from "../../../utils/constants";
import {
  addBeneficiaryApi,
  getBeneficiaryByIdApi,
  updateBeneficiaryApi,
} from "../../../apis/beneficiary.api";
import { callSnackBar } from "../../../store/actions/snackbarAction";
import moment from "moment";
import {
  AudiosGramData,
  beneficiaryFormData,
  validateEmail,
  validatePhone,
  validateaadhar,
} from "../../../utils/helper";
import {
  BENIFICIARY_LOG_STATUS,
  SEVEARITY_OF_LOSS,
  TYPE_OF_HEARING_LOSS,
  WAY_OF_CONFIRMATION,
} from "../../../utils/beneficiary.constant";
import CreateUi from "./CreateUi";
import {
  fetchOscillaDetails,
  fetchOscillaTestStartedDetails,
} from "../../../store/actions/OscillaDataAction";

const CreateController = ({ fetch_id }) => {
  const validate = useValidate();
  const dispatch = useDispatch();
  const params = useParams();
  const modalKey = "beneficiary";
  const title = "Beneficiary ";
  const createApi = addBeneficiaryApi;
  const updateApi = updateBeneficiaryApi;
  const getByIdApi = getBeneficiaryByIdApi;
  const [caseHistory, setCaseHistory] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [step, setStep] = useState(0);
  const { testStarted, data, test_data } = useSelector(
    (state) => state.oscilla,
  );
  const [loading, setLoading] = useState(false);

  const defaultFields = {
    err: "",
    id: "",
    surname: "",
    name: "",
    phone: "",
    email: "",
    photo: "",
    udise_no: "",
    udise_file: "",
    aadhar_file: "",
    income_certi: "",
    gender: GENDER.MALE,
    dob: moment().toISOString(),
    country: beneficiaryFormData.get("country"),
    state: beneficiaryFormData.get("state"),
    district: beneficiaryFormData.get("district"),
    taluka: beneficiaryFormData.get("taluka"),
    addres_line: "",
    PIN: "",
    school: beneficiaryFormData.get("school"),
    std: beneficiaryFormData.get("std"),
    aadhar: "",
    father_name: null,
    father_occupation: null,
    mother_name: null,
    mother_occupation: null,
    family_income: null,
    family_contact: "",
    allowed_ac: true,
    allowed_bc: false,
    allowed_ucl: false,
    allowed_aided: false,
    is_in_camp: false,
    lf1: null,
    lf2: null,
    lf3: null,
    lf3_5: null,
    lf4: null,
    lf4_5: null,
    lf5: null,
    lf5_5: null,
    lf6: null,
    lf6_5: null,
    lf7: null,
    lf8: null,
    rf1: null,
    rf2: null,
    rf3: null,
    rf3_5: null,
    rf4: null,
    rf4_5: null,
    rf5: null,
    rf5_5: null,
    rf6: null,
    rf6_5: null,
    rf7: null,
    rf8: null,

    blf1: null,
    blf2: null,
    blf3: null,
    blf3_5: null,
    blf4: null,
    blf4_5: null,
    blf5: null,
    blf5_5: null,
    blf6: null,
    blf6_5: null,
    blf7: null,
    blf8: null,
    brf1: null,
    brf2: null,
    brf3: null,
    brf3_5: null,
    brf4: null,
    brf4_5: null,
    brf5: null,
    brf5_5: null,
    brf6: null,
    brf6_5: null,
    brf7: null,
    brf8: null,
    type_of_hearing_loss: TYPE_OF_HEARING_LOSS.CONDUCTIVE,
    severity_of_hearing_loss: SEVEARITY_OF_LOSS.MILD,
    audio_gram_file: null,
    nu_device_responce: true,
    music_responce: true,
    voice_responce: true,
    has_smart_phone: true,
    left_response_in_db: 0,
    right_response_in_db: 0,
    way_of_confirmation: WAY_OF_CONFIRMATION.VERBAL_CONFIRMATION,
    product: beneficiaryFormData.get("product"),
    teacher: beneficiaryFormData.get("teacher"),

    camp: beneficiaryFormData.get("camp"),

    before_beneficiary_video: "",
    after_beneficiary_video: "",
    remarks: "",

    wehear_executive_name: "",
    ssa_registered: false,
    disablity_id_no: "",
    family_person_information: {
      person_name: "",
      email: "",
      consanguinitu: "",
    },

    problems: {
      please_tell_us_about_your_hearing_concerns: "",
      hearing: null,
      medical_history: {
        diabetes: false,
        blood_pressure: false,
        heart_problem: false,
        kidney_disease: false,
        tuberculosis: false,
        cancer: false,
        other: "",
        taking_medication: false,
      },
      hearing_difficulty: {
        noisy_place: false,
        quiet_place: false,
        restaurant: false,
        television: false,
        telephone: false,
        one_on_one_talking: false,
      },
      hearing_history: {
        ear_pain: null,
        ear_infection: null,
        ear_surgery: null,
        tinnitus: null,
        fluctuation_in_hearing: null,
        head_ache: false,
        dizziness_vomiting: false,
        noise_exposure: false,
        fullness_in_ear: null,
      },
      hearing_aid: {
        had_hearing_aid: false,
        side: null,
        model: "",
      },
      family_member_hearing_loss: {
        has_family_member_with_hearing_loss: false,
        who: "",
        when_lost_hearing: null,
        additional_information: "",
      },
      conclusion: "",
    },
  };
  const [fields, setFields] = useState(defaultFields);
  useEffect(() => {
    beneficiaryFormData.set("camp", fields.camp);
  }, [fields.camp]);
  useEffect(() => {
    beneficiaryFormData.set("product", fields.product);
  }, [fields.product]);
  useEffect(() => {
    beneficiaryFormData.set("country", fields.country);
  }, [fields.country]);

  useEffect(() => {
    beneficiaryFormData.set("state", fields.state);
  }, [fields.state]);
  useEffect(() => {
    beneficiaryFormData.set("district", fields.district);
  }, [fields.district]);
  useEffect(() => {
    beneficiaryFormData.set("taluka", fields.taluka);
  }, [fields.taluka]);

  useEffect(() => {
    beneficiaryFormData.set("school", fields.school);
  }, [fields.school]);
  useEffect(() => {
    beneficiaryFormData.set("std", fields.std);
  }, [fields.std]);
  useEffect(() => {
    beneficiaryFormData.set("teacher", fields.teacher);
  }, [fields.teacher]);

  useEffect(() => {
    beneficiaryFormData.set(
      "family_person_information",
      fields.family_person_information,
    );
  }, [fields.family_person_information]);

  useEffect(() => {
    beneficiaryFormData.set("problems", fields.problems);
  }, [fields.problems]);
  const validationSchemaForCreate = useMemo(
    () => [
      [
        {
          required: true,
          value: fields.camp,
          field: "Camp ",
        },

        {
          required: true,
          value: fields.country,
          field: "Country",
        },
        {
          required: true,
          value: fields.state,
          field: "State",
        },
        {
          required: true,
          value: fields.district,
          field: "District",
        },
        {
          required: true,
          value: fields.taluka,
          field: "Taluka",
        },
        {
          // required: true,
          value: fields.teacher,
          field: "Teacher ",
        },
        {
          required: true,
          value: fields.name,
          field: "First Name",
        },
        {
          required: true,
          value: fields.phone,

          field: "Phone No. ",
          custom: () => {
            if (!validatePhone(fields.phone)) {
              return "Phone No is invalid.";
            }
            return true;
          },
        },
        {
          value: fields.email,
          field: "Email",
          custom: () => {
            if (
              fields.email &&
              fields.email != "" &&
              !validateEmail(fields.email)
            ) {
              return "Email is invalid.";
            }
            return true;
          },
        },
        {
          required: true,
          value: fields.gender,
          field: "Gender",
        },
        {
          required: true,
          value: fields.dob,
          field: "Date of birth",
        },
        {
          value: fields.std,
          field: "Standard",
          custom: () => {
            if (
              fields.std &&
              fields.std != "" &&
              (isNaN(fields.std) || fields.std > 14 || fields.std < -2)
            ) {
              return "Standard/Grade is invalid.";
            }
            return true;
          },
        },

        {
          required: true,
          value: fields.addres_line,
          field: "Address ",
        },
        {
          value: fields.PIN,
          field: "PIN ",
          custom: () => {
            if (fields.PIN && fields.PIN != "" && !/^\d{6}$/.test(fields.PIN)) {
              return "Invalid PIN";
            }
            return true;
          },
        },
        {
          value: fields.aadhar,
          field: "Aadhar ",
          custom: () => {
            if (
              fields.aadhar &&
              fields.aadhar != "" &&
              !validateaadhar(fields.aadhar)
            ) {
              return "Invalid Aadhar";
            }
            return true;
          },
        },
        {
          required: true,
          value: fields.family_contact,
          field: "Guardian Contact ",
          custom: () => {
            if (!validatePhone(fields.family_contact)) {
              return "Guardian Contact is invalid.";
            }
            return true;
          },
        },
      ],

      [
        // {
        //     required: true,
        //     value: fields.photo,
        //     field: 'Photo Indentity ',
        // }
      ],
      [],
      [
        {
          // required: true,
          value: fields.product,
          field: "Product",
        },
        {
          value: fields.left_response_in_db,
          field: "Left ear response ",
          custom: () => {
            if (
              isNaN(fields.left_response_in_db) ||
              fields.left_response_in_db < 0 ||
              fields.left_response_in_db > 120
            ) {
              return "Left ear response should be between 0 to 120 dB";
            }
            return true;
          },
        },
        {
          value: fields.right_response_in_db,
          field: "Right ear response ",
          custom: () => {
            if (
              isNaN(fields.right_response_in_db) ||
              fields.right_response_in_db < 0 ||
              fields.right_response_in_db > 120
            ) {
              return "Right ear response should be between 0 to 120 dB";
            }
            return true;
          },
        },
        {
          required: false,
          value: fields.remarks,
          field: "Remarks",
        },
      ],
    ],
    [fields],
  );
  const createFunction = async () => {
    const passedData = {};
    const currentFields = { ...fields };

    for (let item in currentFields) {
      if (typeof currentFields[item] === "object") {
        if (item === "family_person_information" || item === "problems") {
          passedData[item] = currentFields[item];
        } else {
          passedData[item] = currentFields[item]?._id || currentFields[item];
        }
      } else {
        passedData[item] = currentFields[item];
      }
    }

    setLoading(true);
    dispatch(
      callApiAction(
        async () => await createApi(passedData),
        async (response) => {
          setLoading(false);
          setFields({
            ...fields,
            _id: response._id,
            camp: fields.camp,
            country: fields.country,
            state: fields.state,
            district: fields.district,
            taluka: fields.taluka,
            teacher: fields.teacher,
            problems: fields.problems,
          });
          setStep(step + 1);
          dispatch(fetchOscillaDetails(response?._id));
          // dispatch(
          //   callSnackBar("Data Added Successfully", SNACK_BAR_VARIETNS.suceess),
          // );
        },
        (err) => {
          setLoading(false);
          setStep(step);
          setFields({ ...fields, err });
          dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.warning));
        },
      ),
    );
  };
  const audiogramKeys = [
    "lf1",
    "lf2",
    "lf3",
    "lf3_5",
    "lf4",
    "lf4_5",
    "lf5",
    "lf5_5",
    "lf6",
    "lf6_5",
    "lf7",
    "rf1",
    "rf2",
    "rf3",
    "rf3_5",
    "rf4",
    "rf4_5",
    "rf5",
    "rf5_5",
    "rf6",
    "rf6_5",
    "rf7",
    "brf1",
    "brf2",
    "brf3",
    "brf3_5",
    "brf4",
    "brf4_5",
    "brf5",
    "brf5_5",
    "brf6",
    "brf6_5",
    "brf7",
    "brf8",
    "urf1",
    "urf2",
    "urf3",
    "urf3_5",
    "urf4",
    "urf4_5",
    "urf5",
    "urf5_5",
    "urf6",
    "urf6_5",
    "urf7",
    "urf8",
    "blf1",
    "blf2",
    "blf3",
    "blf3_5",
    "blf4",
    "blf4_5",
    "blf5",
    "blf5_5",
    "blf6",
    "blf6_5",
    "blf7",
    "blf8",
    "ulf1",
    "ulf2",
    "ulf3",
    "ulf3_5",
    "ulf4",
    "ulf4_5",
    "ulf5",
    "ulf5_5",
    "ulf6",
    "ulf6_5",
    "ulf7",
    "ulf8",
    "mlf1",
    "mlf2",
    "mlf3",
    "mlf3_5",
    "mlf4",
    "mlf4_5",
    "mlf5",
    "mlf5_5",
    "mlf6",
    "mlf6_5",
    "mlf7",
    "mlf8",
    "mrf1",
    "mrf2",
    "mrf3",
    "mrf3_5",
    "mrf4",
    "mrf4_5",
    "mrf5",
    "mrf5_5",
    "mrf6",
    "mrf6_5",
    "mrf7",
    "mrf8",
    "ac_l_125_nh",
    "ac_l_250_nh",
    "ac_l_500_nh",
    "ac_l_750_nh",
    "ac_l_1000_nh",
    "ac_l_1500_nh",
    "ac_l_2000_nh",
    "ac_l_3000_nh",
    "ac_l_4000_nh",
    "ac_l_6000_nh",
    "ac_l_8000_nh",

    "bc_l_125_nh",
    "bc_l_250_nh",
    "bc_l_500_nh",
    "bc_l_750_nh",
    "bc_l_1000_nh",
    "bc_l_1500_nh",
    "bc_l_2000_nh",
    "bc_l_3000_nh",
    "bc_l_4000_nh",
    "bc_l_6000_nh",
    "bc_l_8000_nh",

    "ac_r_125_nh",
    "ac_r_250_nh",
    "ac_r_500_nh",
    "ac_r_750_nh",
    "ac_r_1000_nh",
    "ac_r_1500_nh",
    "ac_r_2000_nh",
    "ac_r_3000_nh",
    "ac_r_4000_nh",
    "ac_r_6000_nh",
    "ac_r_8000_nh",

    "bc_r_125_nh",
    "bc_r_250_nh",
    "bc_r_500_nh",
    "bc_r_750_nh",
    "bc_r_1000_nh",
    "bc_r_1500_nh",
    "bc_r_2000_nh",
    "bc_r_3000_nh",
    "bc_r_4000_nh",
    "bc_r_6000_nh",
    "bc_r_8000_nh",
  ];
  const audiogramData = audiogramKeys?.reduce((acc, key) => {
    acc[key] = fields?.[key] ?? null;
    return acc;
  }, {});

  const updateFunction = async () => {
    let updatedData = { id: fields._id };

    for (let field in fields) {
      const fieldVal = fields[field];

      updatedData[field] =
        typeof fieldVal === "object" && fieldVal !== null
          ? fieldVal._id || fieldVal
          : fieldVal;
    }

    updatedData["status_updated"] = BENIFICIARY_LOG_STATUS.MODIFIED;
    console.log("fileds id", fields._id);
    console.log("updatedData", updatedData.id);
    setLoading(true);
    dispatch(
      callApiAction(
        async () =>
          await updateApi({
            ...updatedData,
            id: fields?._id,
            ...audiogramData,
          }),
        async (response) => {
          setLoading(false);
          dispatch(
            callSnackBar("Operation Successfully", SNACK_BAR_VARIETNS.suceess),
          );
          setStep(0);
          setFields({
            ...defaultFields,
            camp: fields.camp,
            country: fields.country,
            state: fields.state,
            district: fields.district,
            taluka: fields.taluka,
            teacher: fields.teacher,
            problems: fields.problems,
          });
          dispatch(closeModal(modalKey));
          dispatch(closeModal("beneficiary-detailed-view"));
        },
        (err) => {
          setLoading(false);
          setFields({ ...fields, err });
        },
      ),
    );
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (fields?._id) updateFunction();
    else createFunction();
  };
  const fetchById = (id) => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getByIdApi({ id: id ? id : (fields?._id ?? "") }),
        async (response) => {
          setFields({ ...fields, ...response });
          setLoading(false);
          dispatch(fetchOscillaDetails(response?._id));
        },
        (err) => {
          setFields({ ...fields, err });
          setLoading(false);
        },
      ),
    );
  };
  useEffect(() => {
    if (fetch_id) {
      fetchById(fetch_id);
    }
  }, [fetch_id]);
  console.log("step", step);
  const onNextButtonClick = (e) => {
    e?.preventDefault();
    const validationResponse = validate(validationSchemaForCreate[step]);
    if (validationResponse === true) {
      if (step == 2 && !fields?._id) {
        onSubmit(e);
      } else if (step < 6)
        setStep(
          caseHistory && step === 0
            ? 1
            : !caseHistory && step === 0
              ? step + 2
              : step + 1,
        );
      else updateFunction(e);

      setFields({ ...fields, err: "" });
    } else {
      setFields({ ...fields, err: validationResponse });
      dispatch(callSnackBar(validationResponse, SNACK_BAR_VARIETNS.error));
    }
  };

  const onPreviosButtonClick = () => {
    if (!loading) {
      setStep(!caseHistory && step === 2 ? 0 : step - 1 >= 0 ? step - 1 : 0);
    }
  };
  const oscillaTestStarted = JSON.stringify(data) !== JSON.stringify(test_data);

  useEffect(() => {
    if (oscillaTestStarted && testStarted) {
      fetchById(fields?._id, false);
    }
  }, [oscillaTestStarted]);

  useEffect(() => {
    let interval;
    if (testStarted) {
      interval = setInterval(() => {
        dispatch(fetchOscillaTestStartedDetails(fields._id));
      }, 6000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [testStarted]);

  const [oscillaAudiogramState, setOscillaAudiogramState] = useState({
    allowed_Oscilla: false,
  });

  useEffect(() => {
    setOscillaAudiogramState({
      allowed_Oscilla: AudiosGramData(data)?.length > 0 ? true : false,
      ...data,
    });
  }, [data]);
  return (
    <CreateUi
      step={step}
      setStep={setStep}
      loading={loading}
      setCaseHistory={setCaseHistory}
      caseHistory={caseHistory}
      fields={fields}
      setFields={setFields}
      onNextButtonClick={onNextButtonClick}
      onPreviosButtonClick={onPreviosButtonClick}
      setOscillaAudiogramState={setOscillaAudiogramState}
      oscillaAudiogramState={oscillaAudiogramState}
      oscillaAudiogram_id={fields?._id}
      fetchById={fetchById}
      loadAudiogram={() => dispatch(fetchOscillaDetails(fields?._id))}
      fetch_id={fetch_id}
    />
  );
};

export default CreateController;
